export default __webpack_public_path__ + "static/media/NR.607b819c.ico";